// In-memory (NOT persisted) view of the signed-in rep's own remittances, fed by the
// rep portal's Supabase fetch (RLS-scoped, explicit column list). It is a display
// mirror only: nothing here is ever written back, and it is never saved to
// localStorage (Supabase is the only record; a cleared browser loses nothing).
// The rep portal replaces the list only with a SUCCESSFUL fetch result.
import { useState, useEffect } from "react";
import { repVisibleRemittance } from "./repRemittances";

let rows = [];               // rep-visible views of ACTIVE remittances
const listeners = new Set();

export const MY_REMITTANCES = {
  get() { return rows; },
  // Replace from a successful fetch. Only active rows are kept, reduced to the
  // fields a rep may see.
  setFromRows(dbRows) {
    const next = (Array.isArray(dbRows) ? dbRows : []).map(repVisibleRemittance).filter(Boolean);
    rows = next;
    listeners.forEach((fn) => { try { fn(rows); } catch (e) { console.warn("[MY_REMITTANCES] listener threw:", e?.message || e); } });
  },
  // Empty the in-memory mirror only (rep sign-out / rep id change). Nothing stored is touched.
  clear() {
    rows = [];
    listeners.forEach((fn) => { try { fn(rows); } catch (e) { console.warn("[MY_REMITTANCES] listener threw:", e?.message || e); } });
  },
  forInvoice(id) {
    const key = String(id || "");
    if (!key) return null;
    return rows.filter((r) => r.invoiceId === key).reduce((a, b) => (!a || Number(b.id) > Number(a.id) ? b : a), null);
  },
  subscribe(fn) { listeners.add(fn); return () => { listeners.delete(fn); }; },
};

/** The rep-visible active remittance of one invoice (or null); re-renders on change. */
export function useRepRemittanceFor(invoiceId) {
  const [, bump] = useState(0);
  useEffect(() => MY_REMITTANCES.subscribe(() => bump((n) => n + 1)), []);
  return MY_REMITTANCES.forInvoice(invoiceId);
}
